module.exports = "<search *ngIf=\"default | async as tagresults\" [tags]=\"true\" [tagresults]=\"tagresults\" [meta]=\"(tagresults | meta)\" class=\"container\"></search>"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/containers/tags-container/tags-container.template.html
// module id = 882
// module chunks = 2